import { render } from "./distributorsalesreport_form.vue?vue&type=template&id=5b397302&scoped=true"
import script from "./distributorsalesreport_form.vue?vue&type=script&lang=js"
export * from "./distributorsalesreport_form.vue?vue&type=script&lang=js"

import "./distributorsalesreport_form.vue?vue&type=style&index=0&id=5b397302&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b397302"]])

export default __exports__